import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useAiAgent } from 'contexts/AiAgentContext';
import { resolveNavigationRoute } from '../action-handlers/navigation';
import { NavigationItem, PendingInvoice } from '../../types';
import TaskPrompt from './TaskPrompt';
import GradientAiIcon from 'components/icons/GradientAiIcon';

type Props = {
  navigation: NavigationItem;
  pendingInvoice: PendingInvoice | null;
};

const IncomeExpenseTaskPrompt: FC<Props> = ({ navigation, pendingInvoice }) => {
  const history = useHistory();
  const { close } = useAiAgent();
  const resolvedRoute = resolveNavigationRoute(navigation.route);

  const handleNavigate = () => {
    close();
    history.push(resolvedRoute, { pendingInvoice });
  };

  return (
    <TaskPrompt
      icon={<GradientAiIcon size={18} grey />}
      label={navigation.label}
      description={navigation.description}
      primaryAction={{
        label: 'Start',
        onClick: handleNavigate,
      }}
    />
  );
};

export default IncomeExpenseTaskPrompt;
